import { useCompanySettings } from '../../CompanySettingsContext';

/**
 * Returns the tenant's IANA timezone string, or 'UTC' if not yet loaded.
 */
export function useTenantTimezone() {
  const { settings } = useCompanySettings();
  return settings?.timezone || 'UTC';
}
